import {
  Wrench, Cpu, Cog, Factory, Hammer, Zap, Droplets, HardHat,
  CircuitBoard, Gauge, Thermometer, Fan, Layers, Box, Shield, ShieldCheck,
  FileText, AlertTriangle, Bell, Clock, LayoutDashboard,
  Activity, Database, Server, Package, Settings, Search,
  Calendar, ScanLine, BookOpen, ClipboardList, Users,
  Paintbrush, Plug, Truck, Building2, Forklift,
} from "lucide-react";

const ICON_MAP = {
  Wrench, Cpu, Cog, Factory, Hammer, Zap, Droplets, HardHat,
  CircuitBoard, Gauge, Thermometer, Fan, Layers, Box, Shield, ShieldCheck,
  FileText, AlertTriangle, Bell, Clock, LayoutDashboard,
  Activity, Database, Server, Package, Settings, Search,
  Calendar, ScanLine, BookOpen, ClipboardList, Users,
  Paintbrush, Plug, Truck, Building2, Forklift,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function DynamicIcon({ name, size = 18, className = "" }) {
  const IconComponent = ICON_MAP[name] || Wrench;
  return <IconComponent size={size} className={className} />;
}

export default ICON_MAP;
